import { type AxiosResponse } from 'axios'

import { type UserProfile } from '@/types/Auth'
import { type CustomAxiosConfig } from '@/types/axios'
import { type LocaleCodeType } from '@/types/Localization'

import armSecureAxios from './secure-base'

export const login = async (data: { email: string, password: string }, config?: CustomAxiosConfig): Promise<AxiosResponse<any>> => {
  return await armSecureAxios.post('/login', data, { ...config })
}

interface RegistrationDate {
  organization_id: string
  first_name_en: string
  last_name_en: string
  first_name_th: string
  last_name_th: string
  email: string
  mobile: string
  password: string
  confirm_password: string
}

export const registration = async (data: RegistrationDate, config?: CustomAxiosConfig): Promise<AxiosResponse<any>> => {
  return await armSecureAxios.post('/register', data, { ...config })
}

export const resetPassword = async (email: string, config?: CustomAxiosConfig): Promise<AxiosResponse<any>> => {
  return await armSecureAxios.post('/reset-password', { email }, { ...config })
}

interface ChangePasswordDate {
  token: string
  new_password: string
  confirm_new_password: string
}

export const changePassword = async (data: ChangePasswordDate, config?: CustomAxiosConfig): Promise<AxiosResponse<any>> => {
  return await armSecureAxios.post('/change-password', data, { ...config })
}

export const validateResetPassword = async (token: string, config?: CustomAxiosConfig): Promise<AxiosResponse<any>> => {
  return await armSecureAxios.post('/validate-reset-password', { token }, { ...config })
}

export const fetchProfile = async (config?: CustomAxiosConfig): Promise<AxiosResponse<UserProfile>> => {
  return await armSecureAxios.get('/profile', { ...config })
}

interface UpdateProfileData {
  firstNameEN: string
  lastNameEN: string
  firstNameTH: string
  lastNameTH: string
  mobile: string
  imageFile: File | undefined
  languagePreference: LocaleCodeType
}

export const updateProfile = async (
  data: UpdateProfileData,
  config?: CustomAxiosConfig
): Promise<AxiosResponse<UserProfile>> => {
  const form = new FormData()

  if (data.imageFile !== undefined) {
    form.append('image_file', data.imageFile)
  }

  form.append('first_name_en', data.firstNameEN)
  form.append('last_name_en', data.lastNameEN)
  form.append('first_name_th', data.firstNameTH)
  form.append('last_name_th', data.lastNameTH)
  form.append('mobile', data.mobile)
  form.append('language_preference', data.languagePreference)

  return await armSecureAxios.post('/profile', form, { ...config })
}

export const deleteProfileImage = async (config?: CustomAxiosConfig): Promise<AxiosResponse<any>> => {
  return await armSecureAxios.delete('/profile/image', { ...config })
}

const userArmService = {
  login,
  registration,
  resetPassword,
  changePassword,
  fetchProfile,
  updateProfile,
  deleteProfileImage,
  validateResetPassword
}

export default userArmService
